import React from 'react';
import { CadDateTimeValueType } from '../../../../../../Models/CadReportValue';
import {
  FieldItemList,
  FieldItemListType
} from '../../../CommonBody/FieldItemList/FieldItemList';
import { FieldValueType } from '../../../../../../Models';

const getDateAndLTimeFields = (
  datetime: CadDateTimeValueType
): FieldItemListType[] => {
  let fields: FieldItemListType[] = [
    {
      label: 'Received',
      value: datetime['received'] as FieldValueType,
      type: 'datetime'
    },
    {
      label: 'Queued',
      value: datetime['queued'] as FieldValueType,
      type: 'datetime'
    },
    {
      label: 'First Arrived',
      value: datetime['first_arrived'] as FieldValueType,
      type: 'datetime'
    },
    {
      label: 'Last Cleared',
      value: datetime['last_cleared'] as FieldValueType,
      type: 'datetime'
    },
    {
      label: 'Time Response',
      value: datetime['time_response'] as FieldValueType,
      type: 'seconds'
    },
    {
      label: 'Time On Call',
      value: datetime['time_on_call'] as FieldValueType,
      type: 'seconds'
    }
  ];

  return fields;
};

export interface CadDatetimeInformationProps {
  datetime: CadDateTimeValueType;
}

export const CadDatetimeInformation = ({
  datetime
}: CadDatetimeInformationProps): React.ReactElement<CadDatetimeInformationProps> => {
  return (
    <FieldItemList
      title="Date and Time"
      fields={getDateAndLTimeFields(datetime)}
    />
  );
};
